import { type MeasurementUnit } from 'dibs-intl/exports/units';
import { type IntlShape } from 'dibs-react-intl';

export const getAbbreviations = ({
    intl,
    measurementUnit,
}: {
    intl: IntlShape;
    measurementUnit: MeasurementUnit;
}): string => {
    // This turns 'inch' into 'pouce' (fr) or 'inch' (en)
    const translatedLabel = intl
        .formatNumber(0, {
            style: 'unit',
            unit: measurementUnit === 'IN' ? 'inch' : 'centimeter',
            unitDisplay: 'short',
        })
        .replace(/[0-9\s]/g, '') // Strips the number to keep only the word
        .toLocaleUpperCase();

    return translatedLabel;
};

export const LOCAL_STORAGE_KEY = 'userMeasurementUnit';
